import React from 'react'

export default function AgreementText({
  text,
  url,
}: {
  text?: React.ReactNode
  url?: string
}) {
  return (
    <span>
      <a href={url} target="_blank">
        {text}
      </a>
    </span>
  )
}
